import { Action } from "@ngrx/store";
import { AuthState } from "./auth.reducer";

export enum AuthActionTypes {
  SetAuthState = "[Auth] Set State",
  SetGuardedRoute = "[Auth] Set Guarded Route",
}

export class SetAuthState implements Action {
  readonly type = AuthActionTypes.SetAuthState;
  constructor(public state: AuthState) {}
}

export class SetGuardedRoute implements Action {
  readonly type = AuthActionTypes.SetGuardedRoute;
  constructor(public url: string) {}
}

export type AuthActions = SetAuthState | SetGuardedRoute;
